export default __webpack_public_path__ + "static/media/ship-img.55e92d06.png";